import PropTypes from 'prop-types'

export const flashcardsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    thumbnail: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    userTitle: PropTypes.string.isRequired,
  })
)

export const modePropType = PropTypes.oneOf(['default', 'edit', 'reorder'])

export const sharedFlashcardSetPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  flashcardSet: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    flashcardCount: PropTypes.number.isRequired,
  }).isRequired,
  flashcardCategory: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    flashcardCount: PropTypes.number.isRequired,
  }).isRequired,
  teacher: PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    teacherName: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string.isRequired,
  }).isRequired,
  yumiClass: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  studentIds: PropTypes.arrayOf(PropTypes.number), // only include if shared to a subset of the class,
})
